<script >
import ProductRowCard from '@/components/ProductRowCard.vue'

export default {
  name: 'StoreLogDialog',
  components: { ProductRowCard },
  data () {
    return {
      visible: false,
      dataForm: {
        reason: '',
        productType: '产品',
        hasReceipt: '',
        hasBack: '',
        fuzzyOrderCode: '',
        status: null,
        orderCode: '',
        batchCode: '',
        sellerName: '',
        receiverName: '',
        productCode: '',
        skuCode: '',
        productId:'',
        productName: '',
        productColor: '',
        productSize: '',
        productAttr1: '',
        productAttr2: '',
        sourceType: this.sourceType,
        sendDateBegin: '',
        sendDateEnd: '',
        queryType: this.queryType,
        isVirtual: null,
        senderName: ''
      }
    }
  },
  props:{
    title:{
      type: String,
      default: ''
    }
  },
  methods: {
    show(queryForm){
      //合并2个对象
      this.dataForm = Object.assign(this.dataForm, queryForm)
      this.visible = true
      this.$nextTick(() => {
        this.$refs.table.reload()
      })
    },
    cellStyleHandler ({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'orderCode') {
        if (row.orderStatus === this.$const.orderStatus.COMPLETED) {
          return {
            color: '#7e6aff'
          }
        }
      }
      if (column.property === 'count' || column.property === 'sendCount') {
        if (row.type === -1) {
          return {
            color: 'red',
            fontWeight: '600'
          }
        }
      }
      if (column.property === 'senderName' || column.property === 'receiverName') {
        if (row.isVirtual === 0) {
          return {
            color: '#a400a2'
          }
        }
      }
    },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        row.count = row.count * row.type
        row.sendCount = row.sendCount * row.type
        row.fullRemark = [row.remark, row.sendRemark, row.receiveRemark].join(' ')
        row.fullImgs = []
        if (row.imgs) {
          row.imgs = JSON.parse(row.imgs)
          row.fullImgs = row.fullImgs.concat(row.imgs)
        }
        if (row.sendImgs) {
          row.sendImgs = JSON.parse(row.sendImgs)
          row.fullImgs = row.fullImgs.concat(row.sendImgs)
        }
        if (row.receiveImgs) {
          row.receiveImgs = JSON.parse(row.receiveImgs)
          row.fullImgs = row.fullImgs.concat(row.receiveImgs)
        }
      })
    },
  },
}
</script>

<template>
  <el-dialog
      :visible.sync="visible"
      :title="title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <SweetTable ref="table" :selection="true" api-version="v2" url="/trade/factorystorelog/page" :auto-load="false"
                :query-form="dataForm" :before-table-binding="beforeTableBinding"
                :is-page="true"
                :summaries-column="['count','sendCount','backCount','transferCount']"
                :cell-style="cellStyleHandler">
      <el-table-column
          prop="orderCode"
          label="外销合同编号"
          header-align="center"
          align="center" width="160"
          :show-overflow-tooltip="true"
      >
        <template #default="{row}">
          <span>{{ row.orderCode }}</span>
          <el-tag type="success" style="margin-left: 6px;" size="mini"
                  v-if="row.orderStatus===$const.orderStatus.COMPLETED">已结束
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="batchCode"
          label="发货批次号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="110" :show-tooltip-when-overflow="true"
      ></el-table-column>
      <el-table-column
          prop="boxReceiptCode"
          :label="dataForm.productType==='产品'?'出口发票号':'销售开票号'"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="110" :show-tooltip-when-overflow="true" v-if="dataForm.productType==='产品'||showReceiptCode===true"
      ></el-table-column>
      <el-table-column
          prop="senderName"
          label="发货方"
          header-align="center"
          align="center"
          width="120"
          :show-overflow-tooltip="true"
          :formatter="$c.companyNameFormatter"
      ></el-table-column>
      <el-table-column
          prop="receiverName"
          label="收货方"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          width="120"
          :formatter="$c.companyNameFormatter"
      ></el-table-column>
      <el-table-column label="货物信息" min-width="300" :show-overflow-tooltip="true">
        <template #default="{row}">
          <ProductRowCard :product="row.product"></ProductRowCard>
          <div v-if="row.upflowCount>0"
               style="color: rgb(164, 0, 162);border-radius: 2px;border: solid 1px rgb(164, 0, 162);background-color: rgb(164, 0, 162,0.3);font-size: 12px;width: 20px;height: 20px;display: flex;justify-content: center;align-items: center;">
            绑
          </div>
        </template>
      </el-table-column>
      <el-table-column
          prop="sendCount"
          label="发货数"
          header-align="center"
          align="center"
          width="80"
      >
      </el-table-column>
      <el-table-column
          label="收货数"
          header-align="center"
          align="center"
          prop="count"
          width="80"
      >
      </el-table-column>
      <el-table-column
          label="退货数"
          header-align="center"
          align="center"
          prop="backCount"
          width="80"
      >
        <template #default="{row}">
          <el-link type="danger" v-if="row.backCount>0" @click="showBackDetailDialog(row)">{{ row.backCount }}</el-link>
          <span v-else>{{ row.backCount }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="调出数"
          header-align="center"
          align="center"
          prop="transferCount"
          width="80"
      >
        <template #default="{row}">
          <el-link type="danger" v-if="row.transferCount>0" @click="showBackDetailDialog(row)">{{
              row.transferCount
            }}
          </el-link>
          <span v-else>{{ row.transferCount }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="发货单价"
          header-align="center"
          align="center"
          prop="price"
          width="80"
      >
      </el-table-column>
      <el-table-column
          label="操作原因"
          header-align="center"
          width="80"
          align="center"
          prop="reason"
      ></el-table-column>
      <el-table-column
          label="记录时间"
          header-align="center"
          align="left"
          width="220"
      >
        <template #default="{row}">
          <div>发货：{{ row.operateTime }}</div>
          <div>收货：{{ row.status === 10 ? '未确认收货' : row.receiveOptTime }}</div>
          <div>制单：{{ row.createDate }}</div>
        </template>
      </el-table-column>
      <el-table-column
          label="操作人"
          header-align="center"
          width="140"
      >
        <template #default="{row}">
          <div>发货：{{ row.creatorName }}</div>
          <div>收货：{{ row.status === 10 ? '未确认收货' : row.receiveOptManName }}</div>
          <div>制单：{{ row.creatorName }}</div>
        </template>
      </el-table-column>
      <el-table-column
          label="进项发票"
          header-align="center"
          align="center"
          width="120" :show-overflow-tooltip="true"
      >
        <template #default="{row}">
          <span v-if="['库存调配','箱单发货'].indexOf(row.reason)>-1">{{ row.reason }}无需开票</span>
          <template v-else>
            <span v-if="row.status===10">未确认收货,无法开票</span>
            <span v-else-if="row.receiptDetailId">{{ row.receiptCode ? row.receiptCode : '申请中' }}</span>
            <span v-else>未开票</span>
          </template>
        </template>
      </el-table-column>

    </SweetTable>
  </el-dialog>
</template>

<style scoped>

</style>